// 请求封装：同源 cookie、写请求自动带 X-CSRF-Token、401 广播事件让 App 跳登录
let csrf = '';
export class ApiError extends Error { constructor(public status: number, message: string, public body?: unknown) { super(message); } }

export async function api<T = unknown>(path: string, init: RequestInit & { json?: unknown } = {}): Promise<T> {
  const headers: Record<string, string> = { ...(init.headers as Record<string, string> | undefined) };
  let body = init.body;
  if (init.json !== undefined) { headers['content-type'] = 'application/json'; body = JSON.stringify(init.json); }
  const method = (init.method ?? 'GET').toUpperCase();
  if (!['GET', 'HEAD'].includes(method) && csrf) headers['x-csrf-token'] = csrf;
  const res = await fetch('/api' + path, { ...init, method, headers, body, credentials: 'same-origin' });
  if (res.status === 401) { window.dispatchEvent(new Event('opc:unauthorized')); throw new ApiError(401, '未登录'); }
  const text = await res.text();
  let data: any = null;
  try { data = text ? JSON.parse(text) : null; }
  catch {
    const unavailable = [502, 503, 504].includes(res.status);
    throw new ApiError(res.status, unavailable
      ? `服务暂时不可用（${res.status}）。若正在保存，请恢复后先刷新核对结果，再决定是否重试。`
      : `服务器返回了异常内容（${res.status}），请刷新核对；当前操作未确认成功。`);
  }
  if (!res.ok) throw new ApiError(res.status, data?.message ?? res.statusText, data);
  return data as T;
}

export interface Me { userId: string; name: string; roles: string[]; csrf: string; exp: string }
export async function loadMe(): Promise<Me> { const me = await api<Me>('/auth/me'); csrf = me.csrf; return me; }
export function setCsrf(v: string) { csrf = v; }

export const STAGES = ['first_contact', 'intent', 'proposal', 'judgement', 'signed', 'closed'] as const;
export const STAGE_LABEL: Record<string, string> = { first_contact: '初次接触', intent: '意向确认', proposal: '方案报价', judgement: '共同研判', signed: '签约', closed: '关闭' };
export const CLOSE_REASON: Record<string, string> = { price_too_high: '报价过高', vetoed: '领导否决', no_budget: '对方无预算', unfit: '不合适', withdrawn: '对方放弃', other: '其他' };
export const COOP_MODE: Record<string, string> = { contract: '承接', revenue_share: '分润', exchange: '资源置换', free: '无偿' };
export const ITEM_TYPE: Record<string, string> = { activity: '活动', visit: '来访', liaison: '对接', delivery: '交付', publicity: '宣传', internal: '内部', other: '其他' };
export const ITEM_STATUS: Record<string, string> = { todo: '待办', doing: '进行中', done: '完成', cancelled: '取消' };
export const ROLE_LABEL: Record<string, string> = { photo_viewer: '活动图片查看', publicity_editor: '宣发内容编辑', publicity: '内部宣发', admission_exporter: '评分表下载', admission_reviewer: '入驻评委', admin: '管理员', core: '核心成员', staff: '执行人员', external_readonly: '外协只读', gov_viewer: '政府资料账号', knowledge_reader: '资料访客 / 企业资料账号' };
